import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import PageHeader from "../core/App/PageHeader";
import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, Heading } from 'tombac';
import { AddIcon } from 'tombac-icons';
import { CommunicationFormModal } from "./CommunicationFormModal/CommunicationFormModal";
import { CommunicationList } from "./CommunicationList";
import { CommunicationListFilters } from "./CommunicationListFilters";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommunicationsPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    products: [],
    roles: [],
    types: []
  });
  const handleAddClick = () => {
    setIsFormModalOpen(true);
  };
  const closeFormModal = () => {
    setIsFormModalOpen(false);
  };
  useEffect(function updateFiltersFromLocation() {
    const searchParams = new URLSearchParams(location.search);
    const products = searchParams.get('products')?.split(',').filter(Boolean);
    const roles = searchParams.get('roles')?.split(',').filter(Boolean);
    const types = searchParams.get('types')?.split(',').filter(Boolean);
    setFilters({
      products: products ?? [],
      roles: roles ?? [],
      types: types ?? []
    });
  }, [location.search]);
  const handleFiltersChange = filters => {
    setFilters(filters);
    const searchParams = new URLSearchParams();
    const arrayFilters = ['products', 'roles', 'types'];
    arrayFilters.forEach(filter => {
      if (filters[filter]?.length) {
        searchParams.set(filter, filters[filter].join(','));
      } else {
        searchParams.delete(filter);
      }
    });
    history.replace({
      search: searchParams.toString().replace(/%2C/g, ',')
    });
  };
  return /*#__PURE__*/_jsxs(RequireAuth, {
    role: [UserRole.Admin],
    "data-sentry-element": "RequireAuth",
    "data-sentry-component": "CommunicationsPage",
    "data-sentry-source-file": "CommunicationsPage.tsx",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(PageHeader, {
        transparent: true,
        "data-sentry-element": "PageHeader",
        "data-sentry-source-file": "CommunicationsPage.tsx",
        "data-sentry-element": "PageHeader",
        children: [/*#__PURE__*/_jsxs(Box, {
          $display: "flex",
          $alignItems: "center",
          $mb: "2sp",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "CommunicationsPage.tsx",
          "data-sentry-element": "Box",
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h1",
            level: 3,
            $mb: "0sp",
            "data-sentry-element": "Heading",
            "data-sentry-source-file": "CommunicationsPage.tsx",
            "data-sentry-element": "Heading",
            children: "Communications"
          }), /*#__PURE__*/_jsx(Button, {
            $m: "0 3sp",
            onClick: handleAddClick,
            prepend: /*#__PURE__*/_jsx(AddIcon, {}),
            variant: "primary",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "CommunicationsPage.tsx",
            "data-sentry-element": "Button",
            children: "Add new"
          })]
        }), /*#__PURE__*/_jsx(CommunicationListFilters, {
          filters: filters,
          onChange: handleFiltersChange,
          "data-sentry-element": "CommunicationListFilters",
          "data-sentry-source-file": "CommunicationsPage.tsx",
          "data-sentry-element": "CommunicationListFilters"
        })]
      }), /*#__PURE__*/_jsx(CommunicationList, {
        filters: filters,
        "data-sentry-element": "CommunicationList",
        "data-sentry-source-file": "CommunicationsPage.tsx",
        "data-sentry-element": "CommunicationList"
      })]
    }), /*#__PURE__*/_jsx(CommunicationFormModal, {
      initialProducts: filters.products,
      initialRoles: filters.roles,
      isOpen: isFormModalOpen,
      onRequestClose: closeFormModal,
      onSuccess: closeFormModal,
      "data-sentry-element": "CommunicationFormModal",
      "data-sentry-source-file": "CommunicationsPage.tsx",
      "data-sentry-element": "CommunicationFormModal"
    })]
  });
};